<template>
    <div class="about-product">
        <div class="about-product__title" v-if="!tabletMax">
            <h2>{{ $t('About Product') }}</h2>
        </div>
        <div class="about-product__wrap">
            <AboutProductMedia :isFullWidth="false" :product="productSettings" v-if="!tabletMax"/>
            <div class="about-product__wrap-info">
                <h4 class="about-product__wrap-info-name">{{ decodeHtmlEntities(productSettings.name) }}</h4>
                <div class="about-product__wrap-info-row" :class="{
                    justify: (Object.keys(this.product.additional_data).length > 2 && !product?.is_online_game) 
                            || Object.keys(this.product.additional_data).length > 3,
                    flexStart: Object.keys(this.product.additional_data).length < 5 && !product?.is_online_game
                    }" v-if="product">
                    <div class="flex-row" v-if="!product?.is_online_game">
                        <div class="flex-item title">
                            <img src="/img/pages/product/icons/platform.svg" alt="server">
                            {{ $t('Platform') }}:
                        </div>
                        <div class="flex-item">
                            <div class="platform" v-if="activeTabObj?.platform_id">
                                <span class="platform__img">
                                    <svg v-if="activeTabObj.platform_id === 4 || activeTabObj.platform_id === 1" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.16699 4.01074C2.16699 3.38914 2.41392 2.793 2.85346 2.35346C3.293 1.91392 3.88914 1.66699 4.51074 1.66699H16.4899C17.1115 1.66699 17.7077 1.91392 18.1472 2.35346C18.5867 2.793 18.8337 3.38914 18.8337 4.01074V12.8649C18.8337 13.4865 18.5867 14.0827 18.1472 14.5222C17.7077 14.9617 17.1115 15.2087 16.4899 15.2087H13.2555C13.459 15.8902 13.8572 16.4974 14.4014 16.9555C14.5238 17.0589 14.6114 17.1974 14.6525 17.3523C14.6935 17.5071 14.686 17.6709 14.6308 17.8213C14.5757 17.9717 14.4756 18.1016 14.3442 18.1932C14.2128 18.2849 14.0564 18.3339 13.8962 18.3337H7.10449C6.94437 18.3337 6.78811 18.2845 6.65686 18.1928C6.52561 18.101 6.42572 17.9712 6.37071 17.8208C6.31569 17.6704 6.30822 17.5068 6.34929 17.352C6.39036 17.1973 6.47799 17.0588 6.60033 16.9555C7.14407 16.4973 7.54199 15.8901 7.74512 15.2087H4.51074C3.88914 15.2087 3.293 14.9617 2.85346 14.5222C2.41392 14.0827 2.16699 13.4865 2.16699 12.8649V4.01074ZM3.72949 4.01074C3.72949 3.80354 3.8118 3.60483 3.95831 3.45831C4.10483 3.3118 4.30354 3.22949 4.51074 3.22949H16.4899C16.6971 3.22949 16.8958 3.3118 17.0423 3.45831C17.1888 3.60483 17.2712 3.80354 17.2712 4.01074V11.8232C17.2712 12.0304 17.1888 12.2292 17.0423 12.3757C16.8958 12.5222 16.6971 12.6045 16.4899 12.6045H4.51074C4.30354 12.6045 4.10483 12.5222 3.95831 12.3757C3.8118 12.2292 3.72949 12.0304 3.72949 11.8232V4.01074Z" fill="white" fill-opacity="1"/>
                                    </svg>
                                    <svg v-else-if="activeTabObj.platform_id === 7 || activeTabObj.platform_id === 2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.0033 13.3426C18.6452 13.795 17.7678 14.1177 17.7678 14.1177L11.2408 16.4649V14.7339L16.0442 13.0204C16.5893 12.8248 16.673 12.5484 16.2299 12.4033C15.7877 12.2578 14.9869 12.2995 14.4414 12.4959L11.2408 13.6245V11.828L11.4253 11.7654C11.4253 11.7654 12.3502 11.4378 13.6506 11.2935C14.9511 11.1501 16.5435 11.3131 17.7936 11.7875C19.2023 12.2332 19.361 12.8903 19.0033 13.3426ZM11.8621 10.3951V5.96829C11.8621 5.4484 11.7664 4.96979 11.2791 4.83429C10.906 4.71464 10.6745 5.06151 10.6745 5.58098V16.6667L7.68836 15.7178V2.5C8.95802 2.73597 10.8078 3.2938 11.8022 3.62941C14.3311 4.49868 15.1885 5.58056 15.1885 8.01825C15.1885 10.3942 13.7235 11.2948 11.8621 10.3951V10.3951ZM2.20912 14.5529C0.762896 14.1452 0.522206 13.2955 1.1814 12.8061C1.79062 12.3541 2.82667 12.0139 2.82667 12.0139L7.10829 10.4897V12.2274L4.0272 13.3314C3.48294 13.5269 3.39924 13.8037 3.84148 13.9488C4.28414 14.0939 5.08533 14.0526 5.63042 13.8567L7.10829 13.3197V14.8744C7.01459 14.891 6.91007 14.9077 6.81346 14.924C5.33518 15.1658 3.7607 15.0649 2.20912 14.5529V14.5529ZM18.0522 15.2412C18.2392 15.2412 18.4145 15.3138 18.5465 15.4476C18.6785 15.5794 18.7514 15.7553 18.7514 15.9421C18.7514 16.1297 18.6785 16.3048 18.5465 16.4365C18.4145 16.5695 18.2392 16.6421 18.0522 16.6421C17.8652 16.6421 17.6903 16.5695 17.5579 16.4365C17.4259 16.3048 17.3534 16.1297 17.3534 15.9421C17.3534 15.556 17.6666 15.2412 18.0522 15.2412ZM17.4709 15.9421C17.4709 16.0976 17.5313 16.2439 17.6412 16.3531C17.7507 16.464 17.8973 16.5241 18.0522 16.5241C18.3733 16.5241 18.6335 16.2631 18.6335 15.9421C18.6335 15.7861 18.5736 15.6398 18.4632 15.5302C18.3537 15.4193 18.2071 15.3596 18.0522 15.3596C17.8973 15.3596 17.7507 15.4193 17.6412 15.5302C17.5313 15.6398 17.4709 15.7861 17.4709 15.9421V15.9421ZM18.2633 15.5648C18.3399 15.5985 18.3787 15.6636 18.3787 15.7561C18.3787 15.8037 18.3687 15.8437 18.3483 15.875C18.3337 15.8975 18.3129 15.9158 18.2896 15.9316C18.3079 15.9425 18.3241 15.9554 18.3362 15.9704C18.3529 15.9921 18.3624 16.0267 18.3637 16.0738L18.3674 16.1735C18.3687 16.2001 18.3703 16.2206 18.3745 16.2331C18.3787 16.2514 18.3866 16.2631 18.3966 16.2668L18.407 16.2719V16.2831V16.3002V16.3173H18.3899H18.2662H18.2562L18.2512 16.3085C18.2471 16.3002 18.2442 16.2906 18.2413 16.2781C18.2392 16.2669 18.2371 16.2473 18.2358 16.2172L18.2296 16.0934C18.2279 16.0505 18.2133 16.0238 18.1859 16.0096C18.1688 16.0017 18.1405 15.9979 18.1022 15.9979H17.8902V16.3002V16.3173H17.8727H17.7719H17.7549V16.3002V15.5552V15.5381H17.7719H18.1163C18.1755 15.5381 18.225 15.5468 18.2633 15.5648L18.2633 15.5648ZM17.8902 15.8787H18.1059C18.1492 15.8787 18.1838 15.8708 18.2084 15.8545C18.2308 15.8383 18.2417 15.8087 18.2417 15.7657C18.2417 15.719 18.2263 15.6886 18.1938 15.6723C18.1759 15.6636 18.1509 15.6586 18.1192 15.6586H17.8902V15.8787Z" fill="white" fill-opacity="1"/>
                                    </svg>
                                    <svg v-else-if="activeTabObj.platform_id === 8 || activeTabObj.platform_id === 3" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_5226_302540)">
                                        <path d="M9.66931 18.2994C8.38549 18.1765 7.08571 17.7157 5.96914 16.9876C5.0335 16.3775 4.82221 16.1267 4.82221 15.6261C4.82221 14.6207 5.92828 12.8598 7.82069 10.8523C8.89546 9.71222 10.3925 8.37585 10.5544 8.41204C10.8691 8.48237 13.3854 10.9355 14.3274 12.0903C15.817 13.9164 16.5018 15.4116 16.1539 16.0782C15.8895 16.5849 14.2485 17.5753 13.0429 17.9558C12.0492 18.2694 10.7443 18.4023 9.66931 18.2994V18.2994ZM3.55851 14.5808C2.781 13.3887 2.38818 12.215 2.19853 10.5175C2.1359 9.95702 2.15834 9.63641 2.34073 8.48594C2.56805 7.05203 3.38508 5.39319 4.36682 4.3723C4.78495 3.9375 4.8223 3.92691 5.33197 4.09851C5.95091 4.3069 6.61188 4.76314 7.63696 5.68955L8.23505 6.23006L7.90845 6.63107C6.39237 8.49257 4.79193 11.1312 4.18877 12.7636C3.86087 13.6511 3.72862 14.5419 3.8697 14.9128C3.96496 15.1632 3.87746 15.0699 3.55851 14.5808ZM17.2061 14.7836C17.2829 14.4088 17.1857 13.7206 16.9581 13.0264C16.465 11.5231 14.8168 8.7264 13.3034 6.82492L12.827 6.22634L13.3424 5.75332C14.0154 5.13569 14.4827 4.76587 14.9868 4.45181C15.3847 4.20397 15.9532 3.98458 16.1976 3.98458C16.3483 3.98458 16.8787 4.53475 17.3069 5.13516C17.9701 6.06508 18.458 7.19234 18.7052 8.36584C18.8649 9.12407 18.8782 10.7471 18.7309 11.5035C18.6101 12.1242 18.3548 12.9293 18.1058 13.4754C17.9193 13.8846 17.4553 14.6792 17.2519 14.9378C17.1474 15.0707 17.1473 15.0704 17.2061 14.7836H17.2061ZM9.80676 3.7007C9.10846 3.34629 8.03121 2.96585 7.43613 2.8635C7.22751 2.82761 6.87164 2.8076 6.6453 2.81902C6.15432 2.8438 6.17625 2.81814 6.96388 2.44623C7.61871 2.13702 8.16493 1.9552 8.90643 1.79959C9.74055 1.62454 11.3084 1.62248 12.1293 1.79536C13.0159 1.98209 14.0598 2.37038 14.6481 2.7322L14.823 2.83974L14.4218 2.81949C13.6247 2.77926 12.4629 3.10113 11.2156 3.70779C10.8394 3.89078 10.5121 4.03693 10.4883 4.03256C10.4645 4.0282 10.1578 3.87886 9.80676 3.7007V3.7007Z" fill="white" fill-opacity="1"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_5226_302540">
                                        <rect width="16.6667" height="16.6667" fill="white" transform="translate(2.16699 1.66699)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    <svg v-else-if="activeTabObj.platform_id === 6" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_5226_302544)">
                                        <path d="M5.74693 1.72985C4.08717 2.0266 2.75176 3.25504 2.33078 4.86994C2.17895 5.45311 2.1686 5.79472 2.18586 10.3185C2.19621 14.4731 2.19966 14.5697 2.26867 14.8906C2.65169 16.6194 3.88013 17.8513 5.62616 18.2585C5.8539 18.3102 6.14376 18.3206 8.01056 18.331C9.94293 18.3448 10.1431 18.3413 10.1948 18.2895C10.2466 18.2378 10.25 17.5718 10.25 10.0218C10.25 4.42481 10.2397 1.78851 10.2155 1.7402C10.181 1.67809 10.1224 1.67464 8.10028 1.67809C6.45777 1.68154 5.96432 1.69189 5.74693 1.72985ZM8.86978 10.0114V17.0025L7.46536 16.9852C6.17136 16.9714 6.03334 16.9645 5.77454 16.8989C4.66343 16.6125 3.83872 15.7568 3.60753 14.6422C3.53161 14.2937 3.53161 5.70845 3.60408 5.36684C3.81111 4.3972 4.48399 3.5932 5.39152 3.23088C5.847 3.048 6.05749 3.02729 7.53437 3.02384L8.86978 3.02039V10.0114Z" fill="white" fill-opacity="1"/>
                                        <path d="M6.04331 5.12978C5.82592 5.17119 5.49466 5.33682 5.31867 5.4921C4.95635 5.80611 4.77692 6.25124 4.80453 6.77574C4.81833 7.04834 4.83558 7.12081 4.946 7.34165C5.10818 7.67636 5.35318 7.92136 5.68789 8.08699C5.91909 8.20086 5.97775 8.21467 6.27796 8.22502C6.55056 8.23537 6.64718 8.22502 6.83006 8.16291C7.57885 7.91101 8.03089 7.18292 7.90321 6.43758C7.75484 5.55076 6.91288 4.95725 6.04331 5.12978Z" fill="white" fill-opacity="0.7"/>
                                        <path d="M11.9304 1.7C11.9166 1.71035 11.9062 5.45086 11.9062 10.0126C11.9062 17.5385 11.9097 18.3011 11.9615 18.3218C12.0546 18.3563 14.7323 18.3425 15.0636 18.308C16.4646 18.1493 17.6999 17.297 18.3728 16.0306C18.459 15.8684 18.5729 15.5958 18.6316 15.4267C18.849 14.778 18.8421 14.9505 18.8421 9.99193C18.8421 6.03402 18.8352 5.44396 18.7869 5.19206C18.4452 3.39427 17.0753 2.03817 15.2741 1.72761C15.0325 1.6862 14.6599 1.67585 13.459 1.67585C12.6309 1.67585 11.9408 1.6862 11.9304 1.7ZM15.6157 9.21553C16.154 9.35701 16.5957 9.76763 16.7751 10.2921C16.889 10.6165 16.8855 11.0927 16.7717 11.3894C16.5612 11.9346 16.1471 12.3177 15.6157 12.4591C14.753 12.6834 13.8352 12.1624 13.5833 11.3066C13.5074 11.0444 13.5108 10.6027 13.5971 10.3335C13.8559 9.48813 14.753 8.99124 15.6157 9.21553Z" fill="white" fill-opacity="1"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_5226_302544">
                                        <rect width="16.6667" height="16.6667" fill="white" transform="translate(2.16699 1.66699)"/>
                                        </clipPath>
                                        </defs>
                                    </svg>
                                    <svg v-else-if="activeTabObj.platform_id === 16" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path d="M10.3276 1.5H5.88702C5.38703 1.5 4.90747 1.69845 4.55363 2.05172C4.19986 2.405 4.00076 2.88427 4 3.38435V12.6156C4.00076 13.1157 4.19988 13.595 4.55363 13.9483C4.90747 14.3016 5.38703 14.5 5.88702 14.5H10.3276C10.8272 14.5 11.3064 14.3015 11.6595 13.948C12.0126 13.5946 12.2109 13.1153 12.2105 12.6156V3.38435C12.2109 2.88466 12.0126 2.40539 11.6595 2.05202C11.3064 1.69854 10.8272 1.5 10.3276 1.5ZM8.10522 13.7475C7.92376 13.7475 7.74975 13.6754 7.62136 13.5471C7.49307 13.4187 7.421 13.2447 7.421 13.0632C7.421 12.8818 7.49307 12.7078 7.62136 12.5795C7.74974 12.4511 7.92376 12.379 8.10522 12.379C8.28668 12.379 8.4607 12.4511 8.58908 12.5795C8.71737 12.7078 8.78944 12.8818 8.78944 13.0632C8.78944 13.2447 8.71737 13.4187 8.58908 13.5471C8.4607 13.6754 8.28668 13.7475 8.10522 13.7475ZM11.5263 11.558H4.68414V3.75796H11.5263V11.558Z" fill="#fff"/>
                                    </svg>
                                </span>
                                <p>{{ activeTabObj.name }}</p>
                            </div>
                        </div>
                        
                    </div>
                    <div class="flex-row" v-else>
                        <div class="flex-item title">
                            <img src="/img/pages/product/icons/platform.svg" alt="server">
                            {{ $t('Game') }}:
                        </div>
                        <div class="flex-item platform">
                            {{ product.name }}
                        </div>
                    </div>
                    <div class="flex-row" v-if="product?.additional_data?.developer || product?.additional_data?.developergame">
                        <div class="flex-item title">
                            <img src="/img/pages/product/icons/following.svg" alt="faction">
                            {{ $t('Developers') }}:
                        </div>
                        <div class="flex-item">
                            {{ product.additional_data.developer || product.additional_data.developergame}}
                        </div>
                    </div>
                        
                    <div class="flex-row" v-if="product?.additional_data?.release_date && getReleaseDate(product?.additional_data?.release_date)">
                        <div class="flex-item title">
                            <img src="/img/pages/product/icons/calendar.svg" alt="faction">
                            {{ $t('Release Date') }}:
                        </div>
                        <div class="flex-item">
                            {{ getReleaseDate(product.additional_data.release_date)}}
                        </div>
                    </div>
                        
                    <div class="flex-row" v-if="product?.additional_data?.publisher || product?.additional_data?.publishergame">
                        <div class="flex-item title">
                            <img src="/img/pages/product/icons/personal.svg" alt="faction">
                            {{ $t('Publisher') }}:
                        </div>
                        <div class="flex-item">
                            {{ product.additional_data.publisher || product.additional_data.publishergame}}
                        </div>
                    </div>
                        
                    <div class="flex-row" v-if="product?.additional_data?.websiteurl">
                        <div class="flex-item title">
                            <img src="/img/pages/product/icons/planet.svg" alt="faction">
                            {{ $t('Website') }}:
                        </div>
                        <div class="flex-item">
                            {{ product.additional_data.websiteurl }}
                        </div>
                    </div>
                </div>
                <div class="about-product__wrap-info-row" v-else v-for="n in 6" :key="n">
                    <div class="info-label">
                        <span class="placeholder icon"></span>
                        <span class="placeholder text"></span>
                    </div>
                    <div class="info-value placeholder"></div>
                </div>
            </div>
            <RecomendedInfo v-if="recomendedInfo" :recomendedInfo="recomendedInfo"/>
        </div>
        <div class="about-product__description" v-if="(product.description && product.description.trim().length > 5)  || (recomendedInfo || tabletMax)">
            <AboutProductMedia :isFullWidth="true" :product="productSettings" v-if="recomendedInfo || tabletMax"/>
            <div v-if="product.description && product.description.trim().length > 5" class="about-product__description-text" v-html="product.description"></div>
        </div>
    </div>
</template>

<script>
import AboutProductMedia from './AboutProductMedia.vue';
import RecomendedInfo from './RecomendedInfo.vue';
import { decodeHtmlEntities } from '/webpack-assets/vue/utils/decodeHtmlEntities';

export default {
  components: {
    AboutProductMedia,
    RecomendedInfo
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    mobile: {
      type: Boolean,
      default: false
    },
    tablet: {
      type: Boolean,
      default: false
    },
    tabletMax: {
      type: Boolean,
      default: false
    },
    activeTabObj: {
        type: Object,
        default: () => {}
    }
  },
  data() {
    return {
        language: window.common.language.code2,
        recomendedInfo: null,
        productSettings: window.settings.product
    };
  },
  mounted() {

  },
  methods: {
    decodeHtmlEntities,
    getReleaseDate(dateStr) {
      if (!dateStr) return '';

      const locale = this.language || 'en';

      const date = new Date(dateStr);
      if (isNaN(date)) return '';

      if (date.getUTCFullYear() === 1970) return '';

      const day = String(date.getUTCDate()).padStart(2, '0');
      const monthName = new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' }).format(date);
      const year = date.getUTCFullYear();

      return `${day} ${monthName} ${year}`;
    }
  },

};
</script>
  
<style lang="scss" scoped>
    .about-product{
        padding-bottom: 50px;
        &__title{
            padding-bottom: 20px;
            h2{
                font-family: "Avenir-Next-DemiBold", sans-serif;
                font-weight: 400;
                font-size: 22px;
                line-height: 30px;
                letter-spacing: 0px;
                text-transform: uppercase;
                color: #1F1F1F;
            }
        }
        &__wrap{
            display: flex;
            flex-wrap: nowrap;
            gap: 30px;
            padding-bottom: 20px;
            @media only screen and (max-width: 1023px) {
                flex-direction: column;
            }
            &-info{
                border-radius: 16px;
                width: 100%;
                background-color: #fff;
                box-shadow: 0px 4px 10px 0px #8585851A;
                padding: 20px;
                max-width: 50%;
                overflow: hidden;
                display: flex;
                flex-direction: column;
                @media only screen and (max-width: 1023px) {
                    max-width: 100%;
                }
                &-name{
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 32px;
                    line-height: 140%;
                    letter-spacing: 0px;
                    color: #1F1F1F;
                    margin-bottom: 30px;
                    display: block;
                    @media only screen and (max-width: 1919px) {
                        margin-bottom: 20px;
                    }
                    @media only screen and (max-width: 1639px) {
                        margin-bottom: 15px;
                        font-size: 24px;
                    }
                    @media only screen and (max-width: 1279px) {
                        margin-bottom: 7px;
                    }
                    @media only screen and (max-width: 1023px) {
                        margin-bottom: 15px;
                    }
                    &.placeholder{
                        width: 200px;
                        height: 34px;
                        border-radius: 11px;
                    }
                }
                &-row{
                    margin-bottom: 20px;
                    display: flex;
                    flex-direction: column;
                    gap: 14.5px;
                    @media only screen and (max-width: 1919px) {
                        gap: 12.5px;
                    }
                    @media only screen and (max-width: 1639px) {
                        gap: 7px;
                    }
                    @media only screen and (max-width: 1279px) {
                        gap: 1px;
                    }
                    @media only screen and (max-width: 1023px) {
                        gap: 7px;
                    }
                    @media only screen and (max-width: 767px) {
                        gap: 15px;
                    }
                    &.justify{
                        justify-content: space-between;
                        height: 100%;
                    }
                    &.flexStart {
                        justify-content: flex-start;
                        gap: 30px;
                        @media only screen and (max-width: 1279px) {
                            gap: 18px;
                        }
                    }
                    .flex-row{
                        gap: 20px;
                        display: flex;
                        align-items: center;
                        @media only screen and (max-width: 767px) {
                            flex-direction: column;
                            align-items: flex-start;
                            gap: 5px;
                        }
                    }
                    .flex-column{
                        
                        
                    }
                    .flex-item{
                        min-width: 180px;
                        font-size: 18px;
                        width: 100%;
                        &.title{
                            width: 40%;
                        }
                        @media only screen and (max-width: 1639px) {
                            font-size: 16px;
                            min-width: 120px;
                            -webkit-mask-image: linear-gradient(90deg, #fff 90%, transparent);
                        }
                        @media only screen and (max-width: 1199px) {
                            min-width: 150px;
                        }
                        .platform{
                            display: flex;
                            gap: 5px;
                            padding-right: 10px;
                            background: #4E8AFF33;
                            border-radius: 24px;
                            align-items: center;
                            width: fit-content;
                            .platform__img{
                                border-radius: 50%;
                                width: 26px;
                                height: 26px;
                                background-color: #4E8AFF;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                svg{
                                    width: 16px;
                                    height: 16px;
                                }
                            }
                        }
                    }
                    .info-value{
                        height: 24px;
                        width: 200px;
                        border-radius: 11px;
                        @media only screen and (max-width: 1639px) {

                        }
                    }
                    &:last-child{
                        margin-bottom: 0;
                    }
                }
            }
        }
        &__description{
            padding: 15px 20px;
            font-family: "Avenir-Next", sans-serif;
            font-weight: 400;
            font-size: 16px;
            color: #9D9D9D;
            line-height: 20px;
            letter-spacing: 0px;
            border-radius: 16px;
            background-color: #fff;
            box-shadow: 0px 4px 10px 0px #8585851A;
            &-text{
                @media only screen and (max-width: 1023px) {
                    padding-top: 20px;
                }
                // :deep(br){
                //     display: none;
                // }
                :deep(h2),
                :deep(h4),
                :deep(h5),
                :deep(h3){
                    //display: inline-block;
                    font-family: "Avenir-Next-DemiBold", sans-serif;
                    font-weight: 400;
                    font-size: 16px;
                    color: #9D9D9D;
                    line-height: 20px;
                    margin-bottom: 10px;
                }
                :deep(p){
                    //display: inline-block;
                    font-family: "Avenir-Next", sans-serif;
                    font-weight: 400;
                    font-size: 16px;
                    color: #9D9D9D;
                    line-height: 20px;
                }
                :deep(ul){
                    padding-left: 20px;
                }
            }
        }
    }
</style>